import { Map } from 'immutable';
import actions from './actions';

//const initState = { idToken: null };


const initState = new Map({ idToken: null})

export default function authReducer(state = initState, action) {
   switch (action.type) {
    case actions.LOGIN_SUCCESS:
    return state
          .set('id_token', action.token)
          .set('role', action.role)
          .set('id', action.id);
      /* return {
        idToken: action.token,
      }; */
      case actions.FIRST_LOGIN_ERROR:
    return state
          .set('result', action.result) 
      /* return {
        idToken: action.token,
      }; */
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}



